import * as _ from 'lodash';

export default angular.module('cian.newbuild.filter.analyticsService', [])

.factory('AnalyticsService', ['$window', '$rootScope', '$log', 'FilterService', 'SerpViewMode', ($window, $rootScope, $log, FilterService, SerpViewMode) => {
  const service = {};

  let isFirstTracking = true;

  const getDimensions = url => {
    const dims = {};

    // Список регионов
    dims.dimension10 = FilterService.selectedRegions.map(r => r.id).join(', ');

    let dealType = FilterService.dealType;
    if (dealType === 'rent') {
      dealType += FilterService.isShortTerm() ? '_day' : '_long';
    }
    dims.dimension11 = dealType;

    let category = FilterService.category;
    if (category === 'flat') {
      if (FilterService.dealTypeIs('rent')) {
        category = 'flat_old';
      } else {
        switch (FilterService.filter.building_status.value) {
          case 1:
            // Вторичка
            category = 'flat_old';
            break;
          case 2:
            // Новостройка
            category = 'flat_new';
            break;
          default:
            category = 'flat_old,flat_new'
        }
      }
    }
    dims.dimension12 = category;

    dims.dimension13 = 'listing'; // выдача

    // Определяем, была ли предыдущая страница выдачей
    const isPreviousPageSerp = document.referrer.search(/cian\.ru.*(snyat-|kupit-|cat\.php)/) > -1;
    dims.dimension16 = url +
      (isFirstTracking && !isPreviousPageSerp ? '/not_list' : '/list');

    return dims;
  };

  function uniqueArrayKeys(arr) {
    var obj = {};
  
    for (var i = 0; i < arr.length; i++) {
      var str = arr[i];
      obj[str] = true;
    }
  
    return Object.keys(obj);
  }

  function getVariant(offer) {
    let variant = [];

    if (offer.top3) {
      variant.push('top3');
    }

    if (offer.is_payed) {
      variant.push('paid');
    }

    if (offer.premium && offer.premium.state) {
      variant.push('premium');
    }

    if (offer.colorized) {
      variant.push('color');
    }

    if (offer.auction) {
      variant.push('auction');
    }

    if (offer.phone_data_layer && offer.phone_data_layer.variant) {
      variant.concat(offer.phone_data_layer.variant.split('/'));
    }

    return uniqueArrayKeys(variant).filter(Boolean);
  }

  const getProducts = (offers) => {
    const offerArr = Object.keys(offers).map(key => offers[key]);

    const products = offerArr.map((offer, index) => {
      return {
        id: offer.realty_id && Number(offer.realty_id)
          ? Number(offer.realty_id)
          : undefined,
        cianId: offer.id || undefined,
        ownerId: offer.user ? offer.user.id : undefined,
        ownerCianId: offer.user ? offer.user.cianId : undefined,
        dealType: $window._dataLayerBackedObject.page.dealType,
        objectType: $window._dataLayerBackedObject.page.objectType,
        position: offer.phone_data_layer ? offer.phone_data_layer.position : index,
        published: offer.status === 'published',
        variant: getVariant(offer),
        brand: offer.phone_data_layer ? offer.phone_data_layer.brand : undefined,
        hiddenBase: Boolean(offer.isInHiddenBase),
        price: offer.phone_data_layer ? offer.phone_data_layer.price : undefined,
        podSnos: Boolean(offer.isDemolishedInMoscowProgramm),
        owner: Boolean(offer.isByHomeowner),
        photosCount: offer.photos ? offer.photos.length : 0,
        parentId: offer.new_object_id ? Number(offer.new_object_id) : undefined,
      };
    });

    return products;
  };

  service.trackPageView = (params) => {
    const { fullUrl, sortType, searchConditions, pageNumber } = params;
    const pageUrl = $window.location.pathname + $window.location.search;

    try {
      $window.yaCounter34229100 && $window.yaCounter34229100.hit(pageUrl);
      $window.yaCounter67132 && $window.yaCounter67132.hit(pageUrl);

      const { CriteoProducts } = $window._dataLayerBackedObject.partner;

      let advancedParams = {};

      if ($window._dataLayerBackedObject.modelVersion) {
        advancedParams.modelVersion = $window._dataLayerBackedObject.modelVersion;
      }

      const customDataLayerBackedObject = {
        user: {
          ...$window._dataLayerBackedObject.user,
        },
        partner: {
          ...$window._dataLayerBackedObject.partner,
          CriteoProducts: Array.isArray(CriteoProducts)
            ? CriteoProducts.map(criteo => Number(criteo)).filter(Boolean)
            : [],
        },
        page: {
          ...$window._dataLayerBackedObject.page,
          pageNumber: pageNumber || 1,
          queryString: fullUrl,
          listingType: SerpViewMode.getMode(),
          sortType: sortType || 'default',
        },
        products: getProducts($window._offers || []),
        searchConditions,
      };

      const eventParams = {
        action: 'newpage',
        event: 'newpage',
        name: 'newpage',
        category: 'page',
        label: fullUrl,
        ...params,
        ...advancedParams,
        ...customDataLayerBackedObject,
      };

      $window.ca('page', {
        ...customDataLayerBackedObject.page,
      });

      $window.ca('pageviewSite', _.extend(
        eventParams,
      ));

      isFirstTracking = false;
    } catch (err) {
      $log.error(err);
    }
  };

  /**
   * @memberOf AnalyticsService
   * @param {string} category
   * @param {string} action
   * @param {string} label
   * @param {object} [options]
   */
  service.trackCA = (category, action, label, options) => {
    if ($window.ca) $window.ca('event', {
      name: 'oldevent',
      category,
      action,
      label,
      ...options,
    });
  };

  return service;
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/services/analytics.service.js